module.exports = __webpack_public_path__ + "img/LVDNgrandlogo.a2a9ce71.png";